/* Task creation: recipients → existing library → guide goals. No enrollment management here. */
(function () {
  "use strict";

  window.DMSchoolSections = window.DMSchoolSections || {};
  window.DMSchoolSections.tasks = function (ctx) {
    const {
      el: DMSchoolUi,
      b: DMSchoolUiAtual2,
      input,
      opt,
      table,
      csv,
      fmt,
      date,
      minutes,
      yearLabel,
      goalText,
      status,
    } = window.DMSchoolUi;
    const {
      api,
      session,
      house,
      options,
      render,
      heading,
      toolbar,
      empty,
      saveForm,
      note,
      run,
    } = ctx;
    const day = (value) =>
      value
        ? new Intl.DateTimeFormat("en-CA", {
            timeZone: "America/Araguaina",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          }).format(new Date(value.replace(" ", "T") + "Z"))
        : "";
    const accessDay = (value) =>
      value
        ? String(value).slice(0, 10).split("-").reverse().join("/")
        : "Sem acesso";
    const folded = (value) =>
      String(value || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLocaleLowerCase("pt-BR");
    const taskPaging = { page: 0, size: 20 };
    const taskFilters = { query: "", type: "", active: "" };
    const taskTypes = {
      closed: "Questões fechadas",
      open: "Questões abertas",
      flashcard: "Flashcards",
      summary_seconds: "Leitura",
      video_seconds: "Videoaula",
      written: "Entrega escrita",
    };
    function pager(root, rows, draw, size = 20, saved = {}) {
      let page = saved.page || 0;
      const list = DMSchoolUi("div"),
        bar = DMSchoolUi("div", "ds-actions"),
        limit = DMSchoolUi("select");
      limit.setAttribute("aria-label", "Linhas por página");
      opt(limit, 20, "20 por página");
      opt(limit, 50, "50 por página");
      limit.value = saved.size || size;
      root.append(list, bar);
      const update = () => {
        size = Number(limit.value);
        page = Math.min(page, Math.max(0, Math.ceil(rows().length / size) - 1));
        saved.page = page;
        saved.size = size;
        list.replaceChildren();
        draw(list, rows().slice(page * size, (page + 1) * size));
        bar.replaceChildren();
        const prev = DMSchoolUiAtual2("Anterior", () => {
            page--;
            update();
          }),
          next = DMSchoolUiAtual2("Próxima", () => {
            page++;
            update();
          });
        prev.disabled = page === 0;
        next.disabled = (page + 1) * size >= rows().length;
        bar.append(
          prev,
          DMSchoolUi(
            "span",
            null,
            (rows().length ? page * size + 1 : 0) +
              "–" +
              Math.min((page + 1) * size, rows().length) +
              " de " +
              rows().length,
          ),
          next,
          limit,
        );
      };
      limit.onchange = () => {
        page = 0;
        update();
      };
      update();
      return () => {
        page = 0;
        update();
      };
    }
    function tasks() {
      return render(async (value) => {
        heading(value, "Tarefas");
        toolbar(
          value,
          DMSchoolUiAtual2(
            "Nova tarefa",
            () => recipientForm("students"),
            "ds-button ds-primary",
          ),
        );
        const rows = await api.call("sent-tasks", {
          institution_id: house,
        });
        if (!rows.length) return empty(value, "Nenhuma tarefa enviada ainda.");
        const filters = DMSchoolUi("form", "ds-form ds-filter-bar"),
          search = input(filters, "task_search", "Pesquisar tarefas", "search", taskFilters.query),
          type = input(filters, "task_type", "Tipo de tarefa", "select"),
          active = input(filters, "task_active", "Situação", "select");
        opt(type, "", "Todos os tipos");
        for (const [kind, label] of Object.entries(taskTypes)) opt(type, kind, label);
        opt(active, "", "Todas");
        opt(active, "1", "Ativas");
        opt(active, "0", "Arquivadas");
        type.value = taskFilters.type;
        active.value = taskFilters.active;
        filters.onsubmit = (event) => event.preventDefault();
        value.append(filters);
        // O servidor envia somente tarefas da instituição. Filtrar a lista recebida
        // evita uma nova consulta a cada tecla e mantém a atualização periódica.
        const indexed = rows.map((item) => ({
          item,
          text: folded([
            item.title, item.class_name, item.recipient_label, item.sender_name,
            ...(item.recipient_search_names || item.recipient_names || []),
            ...(item.task_guide_names || []),
            ...(item.task_types || []).map((kind) => taskTypes[kind]),
          ].filter(Boolean).join(" ")),
        }));
        const matches = () => {
          const terms = folded(taskFilters.query).trim().split(/\s+/).filter(Boolean);
          return indexed.filter(({ item, text }) =>
            terms.every((term) => text.includes(term)) &&
            (!taskFilters.type || (item.task_types || []).includes(taskFilters.type)) &&
            (taskFilters.active === "" || String(Number(item.active)) === taskFilters.active),
          ).map(({ item }) => item);
        };
        const update = pager(
          value,
          matches,
          (list, page) => {
            if (!page.length) return empty(list, "Nenhuma tarefa corresponde aos filtros.");
            table(
              list,
              ["Atividade", "Destinatários", "Enviada por", "Prazo", "Situação", "Ações"],
              page.map((item) => {
                const DMSchoolUiResult = DMSchoolUi("div", "ds-row-actions");
                DMSchoolUiResult.append(
                  DMSchoolUiAtual2("Ver entregas", () => taskReport(item.id)),
                );
                if (item.can_manage) {
                  DMSchoolUiResult.append(
                    DMSchoolUiAtual2("Duplicar", () => prepareTask(item.id, false)),
                  );
                  if (Number(item.active))
                    DMSchoolUiResult.append(
                      DMSchoolUiAtual2("Editar", () =>
                        prepareTask(item.id, true),
                      ),
                    );
                  DMSchoolUiResult.append(
                    DMSchoolUiAtual2(
                      Number(item.active) ? "Arquivar" : "Reativar",
                      run(async () => {
                        await api.call(
                          "task-status",
                          {
                            id: item.id,
                            active: !Number(item.active),
                          },
                          true,
                        );
                        tasks();
                      }),
                    ),
                  );
                }
                return [
                  item.title,
                  item.recipient_label || "Sem destinatários ativos",
                  item.sender_name || "Administração geral",
                  date(item.due_at),
                  Number(item.active) ? "Ativa" : "Arquivada",
                  DMSchoolUiResult,
                ];
              }),
            );
          },
          20,
          taskPaging,
        );
        const apply = (force = false) => {
          const changed = taskFilters.query !== search.value ||
            taskFilters.type !== type.value || taskFilters.active !== active.value;
          taskFilters.query = search.value;
          taskFilters.type = type.value;
          taskFilters.active = active.value;
          if (changed || force) update();
        };
        search.oninput = () => apply();
        type.onchange = () => apply();
        active.onchange = () => apply();
        filters.append(DMSchoolUiAtual2("Limpar filtros", () => {
          search.value = type.value = active.value = "";
          apply(true);
        }));
      }, { live: true });
    }
    function recipientForm(
      mode = "students",
      existing = null,
      selected = new Set(),
    ) {
      render(async (element) => {
        heading(
          element,
          existing?.editing
            ? "Editar destinatários"
            : "Nova tarefa · destinatários",
        );
        toolbar(
          element,
          DMSchoolUiAtual2("Voltar", tasks),
          DMSchoolUiAtual2(
            "Alunos",
            () => recipientForm("students", existing),
            mode === "students" ? "ds-button ds-primary" : "ds-button",
          ),
          DMSchoolUiAtual2(
            "Turmas",
            () => recipientForm("classes", existing),
            mode === "classes" ? "ds-button ds-primary" : "ds-button",
          ),
        );
        const choices = await api.call("audience-options", {
          institution_id: house,
        });
        const rows =
          mode === "classes"
            ? choices.classes
            : (
                await api.call("task-students", {
                  institution_id: house,
                })
              ).students;
        if (!rows.length)
          return empty(
            element,
            mode === "classes"
              ? "Nenhuma turma ativa cadastrada."
              : "Nenhum aluno cadastrado.",
          );
        if (!selected.size && mode === "students")
          for (const optionalValue of existing?.recipients || [])
            if (Number(optionalValue.active))
              selected.add(String(optionalValue.id));
        const filters = DMSchoolUi("form", "ds-form ds-filter-bar"),
          search = input(filters, "search", "Nome", "search"),
          year = input(filters, "year", "Ano escolar", "select"),
          school = input(filters, "school", "Escola", "select"),
          active = input(filters, "active", "Status", "select"),
          sort = input(filters, "sort", "Último acesso", "select");
        opt(year, "", "Todos os anos");
        for (const value of [
          ...new Set(
            rows
              .map((row) => (mode === "classes" ? row.school_year : row.ano))
              .filter(Boolean),
          ),
        ].sort())
          opt(year, value, yearLabel(value));
        opt(school, "", "Todas as escolas");
        for (const value of [
          ...new Set(rows.map((row) => row.escola).filter(Boolean)),
        ].sort())
          opt(school, value, value);
        school.parentElement.hidden = mode === "classes";
        opt(active, "", "Todos");
        opt(active, "1", "Ativos");
        opt(active, "0", "Desativados");
        active.value = "1";
        active.parentElement.hidden = mode === "classes";
        opt(sort, "name", "Nome");
        opt(sort, "recent", "Mais recente");
        opt(sort, "oldest", "Mais antigo");
        sort.parentElement.hidden = mode === "classes";
        filters.onsubmit = (event) => event.preventDefault();
        element.append(filters);
        const counter = DMSchoolUi("p", "ds-hint"),
          proceed = DMSchoolUiAtual2(
            "Continuar para os materiais",
            run(async () => {
              if (!selected.size)
                throw Error(
                  "Selecione pelo menos um " +
                    (mode === "classes" ? "turma." : "aluno."),
                );
              const filters =
                mode === "classes"
                  ? {
                      class_ids: [...selected].map(Number),
                    }
                  : {
                      student_ids: [...selected].map(Number),
                    };
              const confirmed = await api.call(
                "audience-preview",
                {
                  institution_id: house,
                  filters,
                },
                true,
              );
              if (!confirmed.count)
                throw Error("Não há alunos ativos nesta seleção.");
              taskForm(
                {
                  audience: confirmed.filters,
                  audienceHash: confirmed.hash,
                  members: confirmed.students,
                },
                existing,
              );
            }),
            "ds-button ds-primary",
          );
        const count = () => {
          counter.textContent =
            selected.size +
            " " +
            (mode === "classes"
              ? "turmas selecionadas"
              : "alunos selecionados");
          proceed.disabled = !selected.size;
        };
        count();
        toolbar(element, counter, proceed);
        const list = DMSchoolUi("div");
        element.append(list);
        const matches = () =>
          rows
            .filter(
              (row) =>
                folded(row.nome || row.name).includes(folded(search.value)) &&
                (!year.value || (row.ano || row.school_year) === year.value) &&
                (!school.value || row.escola === school.value) &&
                (mode === "classes" ||
                  active.value === "" ||
                  String(row.ativo) === active.value),
            )
            .sort((left, right) =>
              sort.value === "name"
                ? String(left.nome || left.name).localeCompare(
                    String(right.nome || right.name),
                    "pt-BR",
                  )
                : !left.last_logged
                  ? 1
                  : !right.last_logged
                    ? -1
                    : (sort.value === "recent" ? -1 : 1) *
                      String(left.last_logged).localeCompare(
                        String(right.last_logged),
                      ),
            );
        const draw = pager(list, matches, (root, page) => {
          const all = DMSchoolUi("input");
          all.type = "checkbox";
          all.setAttribute("aria-label", "Selecionar alunos desta página");
          const eligible = page.filter(
            (item) => mode === "classes" || Number(item.ativo),
          );
          all.checked =
            eligible.length > 0 &&
            eligible.every((item) => selected.has(String(item.id)));
          all.onchange = () => {
            for (const optionalValue of eligible)
              all.checked
                ? selected.add(String(optionalValue.id))
                : selected.delete(String(optionalValue.id));
            count();
            redraw();
          };
          table(
            root,
            [
              all,
              mode === "classes" ? "Turma" : "Aluno",
              "Ano escolar",
              ...(mode === "classes"
                ? ["Alunos"]
                : ["Escola", "Status", "Último acesso"]),
            ],
            page.map((item) => {
              const check = DMSchoolUi("input");
              check.type = "checkbox";
              check.setAttribute(
                "aria-label",
                "Selecionar " + (item.nome || item.name),
              );
              check.checked = selected.has(String(item.id));
              check.disabled = mode !== "classes" && !Number(item.ativo);
              check.onchange = () => {
                check.checked
                  ? selected.add(String(item.id))
                  : selected.delete(String(item.id));
                count();
              };
              return [
                check,
                item.nome || item.name,
                yearLabel(item.ano || item.school_year),
                ...(mode === "classes"
                  ? [item.students_count]
                  : [
                      item.escola,
                      Number(item.ativo) ? "Ativo" : "Desativado",
                      accessDay(item.last_logged),
                    ]),
              ];
            }),
          );
        });
        const redraw = () => draw();
        for (const optionalValue of [search, year, school, active, sort]) {
          optionalValue.oninput = redraw;
          optionalValue.onchange = redraw;
        }
      });
    }
    function prepareTask(value, editing) {
      return run(async () => {
        const callResult = await api.call("task-details", {
          id: value,
        });
        recipientForm("students", {
          ...callResult,
          editing,
        });
      })();
    }
    function taskForm(recipients, existing = null) {
      render(async (element) => {
        heading(element, "Selecionar material");
        toolbar(
          element,
          DMSchoolUiAtual2("Alterar destinatários", () =>
            recipientForm(
              "students",
              existing,
              new Set(recipients.members.map((item) => String(item.id))),
            ),
          ),
        );
        element.append(
          DMSchoolUi(
            "p",
            "ds-hint",
            recipients.members.length + " destinatários selecionados.",
          ),
        );
        const choose = DMSchoolUi("div", "ds-actions"),
          stage = DMSchoolUi("div"),
          form = DMSchoolUi("form", "ds-form");
        element.append(choose, stage);
        let current = null,
          parts = [],
          selectionVersion = 0,
          libraryCleanup = null,
          dueValue = day(existing?.due_at);
        ctx.cleanup?.(() => {
          if (libraryCleanup) libraryCleanup();
        });
        const stop = () => {
          if (libraryCleanup) {
            libraryCleanup();
            libraryCleanup = null;
          }
        };
        const chooseLesson = run(async (target) => {
          stop();
          const value = target.aulaId || target.id;
          const version = ++selectionVersion;
          stage.replaceChildren(
            DMSchoolUi("p", "ds-loading", "Carregando guias…"),
          );
          const row = await api.call("task-guide-options", {
            lesson_id: value,
          });
          if (!ctx.alive() || version !== selectionVersion) return;
          current = {
            ...row,
            guias: row.guias.map((guia) => ({
              ...guia,
              nome: guia.display_name || guia.nome,
            })),
          };
          parts = [];
          drawGuides();
        });
        function browse(path) {
          stop();
          ++selectionVersion;
          stage.replaceChildren();
          if (!window.DMInstitutionLibrary?.mount) {
            stage.append(
              DMSchoolUi(
                "p",
                "ds-error",
                "Atualize a página para abrir a biblioteca.",
              ),
            );
            return;
          }
          const type = {
            "/conteudos": "reforco",
            "/simuladores-conteudo": "simuladores",
            "/olimpiada-conteudo": "olimpiadas",
          }[path];
          libraryCleanup = window.DMInstitutionLibrary.mount(
            stage,
            type,
            note,
            session,
            house,
            {
              onSelectLesson: chooseLesson,
            },
          );
        }
        for (const [path, label] of [
          ["/conteudos", "Reforço"],
          ["/simuladores-conteudo", "Simuladores"],
          ["/olimpiada-conteudo", "Olimpíadas"],
        ])
          choose.append(
            DMSchoolUiAtual2(
              "Abrir " + label,
              () => browse(path),
              "ds-button ds-primary",
            ),
          );
        choose.append(
          DMSchoolUiAtual2(
            "Vestibulares",
            run(async () => {
              stop();
              ++selectionVersion;
              const material = await api.call("library", {
                institution_id: house,
                path: "/vestibulares",
              });
              stage.replaceChildren();
              if (!material.html_url)
                return empty(stage, "Ainda não há material nesta biblioteca.");
              const link = DMSchoolUi("a", "ds-button", "Abrir provas");
              link.href = material.html_url;
              link.target = "_blank";
              link.rel = "noopener";
              stage.append(link);
              current = {
                id: "",
                titulo: material.nome_arquivo || "Vestibulares",
                material,
              };
              parts = [
                {
                  kind: "written",
                },
              ];
              drawSend();
            }),
          ),
        );
        function drawGuides() {
          stage.replaceChildren();
          heading(
            stage,
            current.titulo,
            [current.course_name, current.module_name]
              .filter(Boolean)
              .join(" · "),
          );
          const selection = DMSchoolUi("div");
          stage.append(selection);
          table(
            selection,
            ["Selecionar", "Guia", "Atividade"],
            current.guias.map((guia) => {
              const check = DMSchoolUi("input");
              check.type = "checkbox";
              check.setAttribute("aria-label", "Selecionar guia " + guia.nome);
              const numbered = ["closed", "open", "flashcard"].includes(
                guia.kind,
              );
              check.disabled = numbered && !guia.total;
              check.onchange = () => {
                if (check.checked) {
                  if (guia.kind === "written") {
                    parts = [];
                    selection.querySelectorAll("input").forEach((item) => {
                      if (item !== check) item.checked = false;
                    });
                  } else if (parts.some((item) => item.kind === "written")) {
                    parts = [];
                    selection.querySelectorAll("input").forEach((item) => {
                      if (item !== check) item.checked = false;
                    });
                  }
                  parts.push({
                    ...guia,
                    guia_id: guia.id,
                    count: guia.total,
                    minutes: 5,
                  });
                } else parts = parts.filter((item) => item.id !== guia.id);
                drawSend();
              };
              return [
                check,
                guia.nome,
                numbered
                  ? guia.total
                    ? guia.total +
                      " " +
                      (guia.kind === "flashcard" ? "flashcards" : "questões")
                    : "Total ainda não identificado"
                  : guia.kind === "written"
                    ? "Material com entrega escrita"
                    : guia.kind === "video_seconds"
                      ? "Tempo de videoaula"
                      : "Tempo de leitura",
              ];
            }),
          );
          stage.append(form);
          drawSend();
        }
        function drawSend() {
          form.replaceChildren();
          if (!parts.length) {
            form.append(
              DMSchoolUi(
                "p",
                "ds-hint",
                "Marque as guias que os alunos devem realizar.",
              ),
            );
            return;
          }
          heading(form, "Confirmar tarefa");
          for (const optionalValue of parts) {
            if (["closed", "open", "flashcard"].includes(optionalValue.kind)) {
              const field = input(
                form,
                "count_" + optionalValue.id,
                optionalValue.nome + " · quantidade a realizar",
                "number",
                optionalValue.count,
                true,
              );
              field.min = 1;
              field.max = optionalValue.total;
              field.step = 1;
              const hint = DMSchoolUi("p", "ds-hint");
              const calc = () => {
                optionalValue.count = Number(field.value);
                hint.textContent =
                  optionalValue.count +
                  " de " +
                  optionalValue.total +
                  " " +
                  (optionalValue.kind === "flashcard"
                    ? "flashcards"
                    : "questões");
              };
              field.oninput = calc;
              calc();
              form.append(hint);
            } else if (optionalValue.kind !== "written") {
              const field = input(
                form,
                "minutes_" + optionalValue.id,
                optionalValue.nome + " · tempo (minutos)",
                "number",
                optionalValue.minutes,
                true,
              );
              field.min = 1;
              field.max = 600;
              field.step = 1;
              field.oninput = () =>
                (optionalValue.minutes = Number(field.value));
            }
          }
          const due = input(form, "due", "Prazo (opcional)", "date", dueValue);
          due.oninput = () => (dueValue = due.value);
          const button = DMSchoolUi(
            "button",
            "ds-button ds-primary",
            existing?.editing ? "Salvar tarefa" : "Enviar tarefa",
          );
          button.type = "submit";
          form.append(button);
          if (!form.isConnected) stage.append(form);
          form.onsubmit = async (event) => {
            event.preventDefault();
            button.disabled = true;
            try {
              const payload = {
                institution_id: house,
                id: existing?.editing ? existing.id : 0,
                audience: recipients.audience,
                audience_hash: recipients.audienceHash,
                lesson_id: current.id,
                due: due.value,
              };
              if (existing?.editing) payload.revision = existing.revision;
              if (parts[0].kind === "written") {
                payload.title = current.titulo;
                payload.instructions =
                  "Realize a atividade do material indicado e envie uma resposta completa.";
                payload.guia_id = parts[0].guia_id || "";
                for (const optionalValue of [
                  "closed",
                  "flashcard",
                  "open",
                  "summary_seconds",
                  "video_seconds",
                ])
                  payload["target_" + optionalValue] = 0;
                if (current.material)
                  payload.target_material = {
                    kind: "vestibulares",
                    html_url: current.material.html_url,
                  };
              } else
                payload.plan_parts = parts.map((item) => ({
                  guia_id: item.guia_id,
                  fingerprint: item.fingerprint,
                  ...(["closed", "open", "flashcard"].includes(item.kind)
                    ? {
                        count: item.count,
                      }
                    : {
                        minutes: item.minutes,
                      }),
                }));
              const sent = await api.call(
                existing?.editing ? "task-update" : "task-create",
                payload,
                true,
              );
              stop();
              tasks();
              note(
                "Tarefa " +
                  (existing?.editing ? "atualizada" : "enviada") +
                  " para " +
                  sent.recipients +
                  " alunos.",
              );
            } catch (err) {
              note(err.message);
            } finally {
              if (ctx.alive()) button.disabled = false;
            }
          };
        }
        if (existing?.lesson) {
          await chooseLesson({
            id: existing.lesson.id,
          });
          const plan =
            existing.material?.kind === "study_plan"
              ? existing.material.parts
              : null;
          if (plan) {
            parts = plan.map((event) => ({
              ...current.guias.find(
                (guia) => String(guia.id) === String(event.guia_id || ""),
              ),
              ...event,
              id: event.guia_id || "",
              guia_id: event.guia_id || "",
              count: event.target,
              minutes: event.target / 60,
            }));
            drawSend();
            for (const check of stage.querySelectorAll("input[type=checkbox]"))
              check.checked = parts.some(
                (item) =>
                  check.getAttribute("aria-label") ===
                  "Selecionar guia " + item.nome,
              );
          }
        }
      });
    }
    const taskGrade = (value) => value == null ? "—" : fmt(value) + " / 10";
    const taskResultText = (value) =>
      "Feitas: " + fmt(value.answered) +
      " · Acertos: " + fmt(value.correct) +
      " · Erros: " + fmt(value.incorrect) +
      (Number(value.partial) > 0 ? " · Parciais: " + fmt(value.partial) : "");
    const taskGradeValue = (student) =>
      student.goals.some((goal) => goal.results)
        ? student.answer_summary?.task_grade
        : student.delivery?.grade;
    const taskCompletionText = (value) =>
      value?.target > 0
        ? "Realizadas: " + fmt(value.credited_answers) + " / " + fmt(value.target) +
          " · " + fmt(value.completion_percent) + "%"
        : "";
    const taskGoalResults = (goal) =>
      goalText(goal) + (goal.results
        ? " · " + taskResultText(goal.results) + " · " + taskCompletionText(goal.results) + " · Nota: " + taskGrade(goal.results.task_grade)
        : "");
    function taskReport(value) {
      return render(async (element) => {
        const callResult = await api.call("task-report", {
          id: value,
        });
        heading(
          element,
          callResult.task.title,
          fmt(callResult.completed) +
            " de " +
            fmt(callResult.total) +
            " concluíram · " +
            date(callResult.task.due_at),
        );
        toolbar(
          element,
          DMSchoolUiAtual2("Voltar às tarefas", tasks),
          DMSchoolUiAtual2("Exportar entregas", () =>
            csv(
              "tarefa-" + value,
              ["Aluno", "Situação", "Atrasada", "Feitas", "Acertos", "Erros", "Parciais", "Questões solicitadas", "Questões computadas na meta", "Realização (%)", "Nota geral (0 a 10)", "Resultados por guia", "Nota da entrega escrita", "Comentário"],
              callResult.students.map((student) => [
                student.nome,
                status[student.status],
                student.late ? "Sim" : "Não",
                student.answer_summary?.answered ?? 0,
                student.answer_summary?.correct ?? 0,
                student.answer_summary?.incorrect ?? 0,
                student.answer_summary?.partial ?? 0,
                student.answer_summary?.target ?? "",
                student.answer_summary?.credited_answers ?? "",
                student.answer_summary?.completion_percent ?? "",
                taskGradeValue(student) ?? "",
                student.goals.map(taskGoalResults).join(" | "),
                student.delivery?.grade ?? "",
                student.delivery?.feedback ?? "",
              ]),
            ),
          ),
        );
        element.append(
          DMSchoolUi("p", "ds-instructions", callResult.task.instructions),
        );
        if (!callResult.students.length)
          return empty(
            element,
            "Esta tarefa não tem destinatários da instituição atual.",
          );
        table(
          element,
          ["Aluno", "Situação", "Metas / resultados", "Resultado geral", "Nota", "Acompanhamento"],
          callResult.students.map((student) => {
            const detail = DMSchoolUi("div");
            for (const goal of student.goals) {
              detail.append(DMSchoolUi("div", null, goalText(goal)));
              if (goal.results) detail.append(DMSchoolUi("div", "ds-hint",
                taskResultText(goal.results) + " · " + taskCompletionText(goal.results) +
                " · Nota: " + taskGrade(goal.results.task_grade)));
            }
            if (student.late)
              detail.append(DMSchoolUi("strong", "ds-late", "Prazo vencido"));
            if (!student.goals.length)
              detail.append(
                DMSchoolUi(
                  "span",
                  null,
                  student.delivery
                    ? "Entrega escrita enviada"
                    : "Aguardando entrega escrita",
                ),
              );
            const DMSchoolUiResult = DMSchoolUi("div", "ds-row-actions");
            if (student.delivery)
              DMSchoolUiResult.append(
                DMSchoolUiAtual2("Ver entrega", () =>
                  reviewForm(callResult.task, student),
                ),
              );
            if (callResult.task.can_manage) DMSchoolUiResult.append(
              DMSchoolUiAtual2(
                "Retirar destinatário",
                run(async () => {
                  await api.call(
                    "task-recipient-status",
                    {
                      id: callResult.task.id,
                      student_ids: [student.student_id],
                      active: false,
                    },
                    true,
                  );
                  taskReport(value);
                  note(
                    "Envio arquivado para este aluno. Histórico preservado.",
                  );
                }),
              ),
            );
            const overall = DMSchoolUi("div");
            if (student.goals.some((goal) => goal.results)) {
              overall.append(DMSchoolUi("div", null, taskResultText(student.answer_summary || {})));
              overall.append(DMSchoolUi("div", "ds-hint", taskCompletionText(student.answer_summary)));
            } else overall.textContent = "—";
            return [
              student.nome,
              status[student.status],
              detail,
              overall,
              taskGrade(taskGradeValue(student)),
              DMSchoolUiResult,
            ];
          }),
        );
        element.append(DMSchoolUi("p", "ds-hint",
          "Resultados por guia e nota geral usam a primeira resposta de cada atividade, mesmo com a tarefa em andamento. A nota considera todas as questões solicitadas: as não respondidas não recebem pontos. Se realizar 10% e acertar tudo, a nota será 1 de 10. Questões extras em uma guia não compensam outras guias pendentes. Flashcards usam autoavaliação. Leitura e videoaula contam tempo, sem nota."));
      }, { live: true });
    }
    function reviewForm(task, item) {
      render(async (element) => {
        heading(
          element,
          item.nome + " · " + task.title,
          "Entrega em " + date(item.delivery.submitted_at),
        );
        toolbar(
          element,
          DMSchoolUiAtual2("Voltar às entregas", () => taskReport(task.id)),
        );
        element.append(
          DMSchoolUi("div", "ds-response", item.delivery.response),
        );
        if (!task.can_manage) return;
        const form = DMSchoolUi("form", "ds-form"),
          grade = input(
            form,
            "grade",
            "Nota (opcional, de 0 a 10)",
            "number",
            item.delivery.grade,
          );
        grade.min = 0;
        grade.max = 10;
        grade.step = 0.1;
        input(
          form,
          "feedback",
          "Comentário ao aluno",
          "textarea",
          item.delivery.feedback || "",
        );
        const inputResult = input(form, "status", "Resultado", "select");
        opt(
          inputResult,
          "reviewed",
          "Corrigida (metas continuam obrigatórias)",
        );
        opt(inputResult, "returned", "Devolver para revisão");
        saveForm(element, form, "Salvar correção", async (value) => {
          await api.call(
            "task-review",
            {
              ...value,
              id: task.id,
              student_id: item.student_id,
            },
            true,
          );
          taskReport(task.id);
        });
      });
    }
    return {
      tasks,
      taskReport,
    };
  };
})();
